import React from "react";
import "./Step5.css";
import { Form } from "react-bootstrap";

function Step5({ next, back ,Institute,setInstitute}) {
  return (
    <div className="step5_main">
      <h2 className="step_title">
        Just Answer <span>3</span> Simple questions to become a <br />
        <strong>Profcyma Partner</strong>
      </h2>

      <p className="step_subtitle">
       Name of your Educational Institute -
      </p>

      <div className="form_holder">
        <div className="field_holder">
            <Form.Control
            as="textarea"
            rows={4}
            placeholder="Write here..."
            value={Institute}
            onChange={(e) => setInstitute(e.target.value)}
          />
        </div>
      </div>

      <div className="step_btns">
        <button onClick={back} className="back_btn">
          Back
        </button>
        <button onClick={next} className="next_btn">
          Next
        </button>
      </div>
    </div>
  );
}

export default Step5;
